import React, { useEffect, useState } from 'react';
import { Box, Grid2 as Grid } from '@mui/material';
import OfferTemplatePreview from './OfferTemplatePreview';
import { useParams } from 'react-router-dom';
import useCandidateOfferService from '../candidateOfferService';
import OfferMarkdownEditor from './OfferMarkdownEditor';
import { useShowContext } from 'framework/show';
import { useMessageService, ErrorMessage } from 'framework/ui/Message';
import { useVacancyGroupService } from 'domain/shared/newVacancy';
import { Loading } from 'framework/ui/mui-builder';
import JobOfferPdfGenerator from './JobOfferPdfGenerator';
import { useOfferTemplateData } from './useOfferTemplateData';
import { markdownToHtml, replacePlaceholders } from 'framework/markdownEditor';

const OfferTemplateWorkspace = () => {
  const [previewHtml, setPreviewHtml] = useState<string>('');
  const { data: candidateData } = useShowContext();
  const { offerId } = useParams();
  const { getById } = useCandidateOfferService();
  const { search } = useVacancyGroupService();
  const { addMessage } = useMessageService();

  const handleContentChange = (content: string) => {
    setEditedContent(content);
  };

  const { isLoading, editedContent, placeholderValues, setEditedContent, firstName, fullName } = useOfferTemplateData({
    offerId,
    candidateData,
    getById,
    search,
  });

  useEffect(() => {
    if (editedContent) {
      try {
        const contentWithValues = replacePlaceholders(editedContent, placeholderValues);

        const html = markdownToHtml(contentWithValues);
        setPreviewHtml(html);
      } catch (err) {
        addMessage(new ErrorMessage('Error during rendering Markdown to HTML'));
      }
    }
  }, [addMessage, editedContent, placeholderValues]);

  if (isLoading) {
    return <Loading />;
  }

  return (
    <Box>
      <Grid container spacing={2} pr={2} sx={{ position: 'relative' }}>
        <Grid size={{ xs: 12, md: 6 }}>
          <OfferMarkdownEditor value={editedContent} onChange={handleContentChange} />
        </Grid>

        <Grid size={{ xs: 12, md: 6 }}>
          <OfferTemplatePreview html={previewHtml} />
          <JobOfferPdfGenerator
            offerId={offerId || ''}
            editedContent={editedContent}
            placeholderValues={placeholderValues}
            firstName={firstName}
            fullName={fullName}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default OfferTemplateWorkspace;
